'use strict';

// Converted from CoffeeScript to JavaScript - ETNA Authenticator HTTP Error Interceptor
intra_module.factory("httpErrorBroadcastor", ['$rootScope', '$location', '$q', function($rootScope, $location, $q) {
    return {
        responseError: function(rejection) {
			try {
				const url = new URL(rejection.config.url);
				const window_domain = window.location.hostname.split('.').slice(1).join(".");
				const url_domain = url.hostname.split('.').slice(1).join(".");

				if (url_domain == window_domain) {
					$rootScope.$broadcast("http:" + rejection.status, rejection);
				}
			} catch (err) {
				console.error("Cannot parse rejection URL:", err);
			}
            return $q.reject(rejection);
        }
    };
}]);

intra_module.config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push("httpErrorBroadcastor");
}]);
